var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
/*
  This component should not be re-used anywhere
  it's has very limited formatting and only handles US phone numbers
*/
import { useState } from 'react';
import { Input } from '../../../../../../infra/dls/components/input';
var formatUSPhoneNumber = function (phoneNumber) {
    var cleaned = phoneNumber.replace(/\D/g, ''); // removes all non digits
    if (cleaned.length === 0) {
        return '';
    }
    if (cleaned.length === 1) {
        return "+".concat(cleaned);
    }
    if (cleaned.length <= 4) {
        return "+".concat(cleaned[0], " (").concat(cleaned.substring(1));
    }
    if (cleaned.length <= 7) {
        return "+".concat(cleaned[0], " (").concat(cleaned.substring(1, 4), ") ").concat(cleaned.substring(4));
    }
    return "+".concat(cleaned[0], " (").concat(cleaned.substring(1, 4), ") ").concat(cleaned.substring(4, 7), "-").concat(cleaned.substring(7, 11));
};
var parseUSPhoneNumber = function (formatted) {
    return formatted.replace(/\D/g, '');
};
export var DemoUSPhoneInput = function (_a) {
    var value = _a.value, onChange = _a.onChange, props = __rest(_a, ["value", "onChange"]);
    var _b = useState(formatUSPhoneNumber(value)), displayValue = _b[0], setDisplayValue = _b[1];
    var handleChange = function (e) {
        var rawValue = parseUSPhoneNumber(e.target.value);
        var formattedValue = formatUSPhoneNumber(e.target.value);
        setDisplayValue(formattedValue);
        onChange(rawValue);
    };
    return _jsx(Input, __assign({}, props, { type: "tel", value: displayValue, onChange: handleChange }));
};
